"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTabFacets = buildTabFacets;
exports.buildTabFacetsRequests = buildTabFacetsRequests;
exports.getZendeskLocaleBySearchState = getZendeskLocaleBySearchState;

var _constants = require("../../constants");

var _SearchService = _interopRequireDefault(require("@insided/destination/modules/Search/services/SearchService"));

var _search = require("@insided/destination/modules/Search/utils/search");

var _filtersBuilder = require("../../utils/filters-builder");

var communityId = (0, _search.getCommunityId)();
/**
 *
 * @param query
 * @description Prepare "requests" to get facets data i.e., content_type and external source (just apply search query and not any facets/filters)
 * @reason If we apply any filters, algolia by default returns facets based on filtered data (so you wont see facets that doesnt have data after applying filters)
 * But in our case, we are building custom tabs and we want to show all the facets irrespective of the filters (sidebar filters) applied
 */

function buildTabFacetsRequests(query) {
  var _allowedIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var includedDataSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var hiddenCategories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var restrictSearchableAttributes = (0, _search.getRestrictedSearchableAttributes)();
  return [// 1 request to get community sources (actually count of all the sources)
  {
    indexName: communityId,
    query: query !== null && query !== void 0 ? query : '',
    params: {
      hitsPerPage: 0,
      facets: ['gs_data_source'],
      query: query,
      facetingAfterDistinct: true,
      restrictSearchableAttributes: restrictSearchableAttributes,
      analytics: false,
      // Exclude from search analytics to avoid inflating Total Searches count
      filters: (0, _filtersBuilder.stringifyFilterExpression)({
        operator: 'AND',
        operands: [{
          key: 'gs_data_source',
          value: 'community'
        }, {
          operator: 'AND',
          operands: hiddenCategories.map(function (value) {
            return {
              operator: 'NOT',
              operand: {
                key: 'forum',
                value: value
              }
            };
          }),
          noParentheses: true // because algolia doesnt support (A AND B) AND C. We need to do A AND B AND C

        }]
      })
    }
  }, // 1 request to get all the sources from external gs_data_source
  {
    indexName: communityId,
    query: query !== null && query !== void 0 ? query : '',
    params: {
      hitsPerPage: 0,
      facets: ['source'],
      query: query,
      facetingAfterDistinct: true,
      restrictSearchableAttributes: restrictSearchableAttributes,
      analytics: false,
      // Exclude from search analytics to avoid inflating Total Searches count
      filters: (0, _filtersBuilder.stringifyFilterExpression)({
        operator: 'AND',
        operands: [{
          operator: 'OR',
          operands: includedDataSource.map(function (item) {
            return {
              key: 'gs_data_source',
              value: item
            };
          })
        }, {
          operator: 'AND',
          operands: hiddenCategories.map(function (value) {
            return {
              operator: 'NOT',
              operand: {
                key: 'forum',
                value: value
              }
            };
          }),
          noParentheses: true // because algolia doesnt support (A AND B) AND C. We need to do A AND B AND C

        }]
      })
    }
  }];
}
/**
 *
 * @description Extract tabFacets data from the algolia response and set it in the searchService
 */


function buildTabFacets(_ref) {
  var _communityResponse$fa, _communityResponse$fa2, _communityResponse$fa3, _externalSourcesRespo, _externalSourcesRespo2;

  var tabFacetsResponse = _ref.tabFacetsResponse,
      selectedSource = _ref.selectedSource,
      _selectedContentType = _ref._selectedContentType,
      selectedGsDataSource = _ref.selectedGsDataSource;
  var tabFacets = [];
  var communityResponse = tabFacetsResponse[0];
  var communitySourcesCount = (_communityResponse$fa = communityResponse === null || communityResponse === void 0 ? void 0 : (_communityResponse$fa2 = communityResponse.facets) === null || _communityResponse$fa2 === void 0 ? void 0 : (_communityResponse$fa3 = _communityResponse$fa2.gs_data_source) === null || _communityResponse$fa3 === void 0 ? void 0 : _communityResponse$fa3.community) !== null && _communityResponse$fa !== void 0 ? _communityResponse$fa : 0;
  var externalSourcesResponse = tabFacetsResponse[1];
  var externalSources = (_externalSourcesRespo = externalSourcesResponse === null || externalSourcesResponse === void 0 ? void 0 : (_externalSourcesRespo2 = externalSourcesResponse.facets) === null || _externalSourcesRespo2 === void 0 ? void 0 : _externalSourcesRespo2.source) !== null && _externalSourcesRespo !== void 0 ? _externalSourcesRespo : {};
  tabFacets.push({
    count: communitySourcesCount,
    isRefined: selectedGsDataSource === 'community',
    label: 'community',
    type: 'gs_data_source',
    id: generateRandomID()
  });
  Object.keys(externalSources) // only show tabs for external sources.
  // This filter is not needed if we have external sources available,
  // in that case it will prepare the query (in buildTabFacetsRequests) to include only external sources
  // But when we don't have external sources (empty []), the filter becomes empty which fetches data for all sources (including internal in this case)
  .filter(function (item) {
    return !['community', 'knowledge_base'].includes(item);
  }).forEach(function (source) {
    return tabFacets.push({
      count: externalSources[source],
      isRefined: source === selectedSource,
      label: source,
      type: 'source',
      id: generateRandomID()
    });
  });
  var selectedTab = selectedGsDataSource || selectedSource; // If there are no results, then add "selected tab" manually (to show the no results screen inside it)

  if (selectedTab && !tabFacets.some(function (item) {
    return item.isRefined;
  })) {
    var selectedTabType = selectedSource ? 'source' : 'content_type';
    tabFacets.push({
      count: 0,
      isRefined: true,
      label: selectedTab,
      type: selectedTabType,
      id: generateRandomID()
    });
  }

  _SearchService.default.tabFacets = (0, _search.sortArrayBySortOrder)({
    data: tabFacets,
    key: 'label',
    sortOrder: _constants.SOURCE_SORT_ORDER
  });
}

function generateRandomID() {
  return "".concat(Math.random().toString(36).substring(2, 10), "-").concat(Math.random().toString(36).substring(2, 10));
}

function getZendeskLocaleBySearchState(state) {
  var _state$indices, _state$indices$, _state$indices$$refin;

  return (_state$indices = state.indices) === null || _state$indices === void 0 ? void 0 : (_state$indices$ = _state$indices["".concat(communityId, "-zendesk")]) === null || _state$indices$ === void 0 ? void 0 : (_state$indices$$refin = _state$indices$.refinementList) === null || _state$indices$$refin === void 0 ? void 0 : _state$indices$$refin.locale;
}